import axios from 'axios'
import { LISTAR_FILTROS_ROTA_ITINERARIO } from '../types'
import { URL } from '../../util/ambienteActions';

export default function listarFiltrosRotaItinerario () {
  const url = `${URL}/rota/itinerario/filtros`
  
  return dispatch => axios.get(url).then(
      response => dispatch({
        type: LISTAR_FILTROS_ROTA_ITINERARIO,
        payload: response

      })
  );
}
